import React from 'react';
import '../../style/Blog.css';

const Footer = () => {
  return (
    <footer className="retro-footer">
      <div className="container text-center">
        <p>&copy; 2026 Brian Bamba</p>
        <p>
          <a href="https://www.linkedin.com/in/brianbamba/" target="_blank" rel="noopener noreferrer" className="footer-link">
          LinkedIn
          </a>
          <span>|</span> 
          <a href="https://www.github.com/briancarlobamba" target="_blank" rel="noopener noreferrer" className="footer-link">
          GitHub
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
